
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */
import { Link, Image, Tracking } from 'contentbricks'

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <Image className='bigImage' file={require('images/grafik_accu.jpg')} mdxType="Image" />
    <p>{`Ja, zum Beispiel regelmässiger aerober Ausdauersport oder Akupunktur. Etliche
der schon erwähnten Methoden wie Entspannungsverfahren, kognitive
Verhaltenstherapie oder Biofeedback werden ebenfalls zur Vorbeugung eingesetzt.
Käufliche Selbstlernprogramme gibt es zum Beispiel `}<Link href='https://neuro-media.de' mdxType="Link">{`hier`}</Link>{`. Auch die medikamentöse Blockade
eines Nervs am Hinterkopf kann helfen – sowie die elektrische Stimulation von
Nerven im Bereich der Stirn und des Nackens (TENS). Rund 2 Tage weniger Migräne
pro Monat brachte in einer Studie ein kleines Elektrostimulationsgerät namens
Cefaly zum Anbringen auf der Stirn oder am Hinterkopf. Es kann auch beim akuten
Anfall schmerzlindernd wirken. «Migränechirurgie» oder Piercings an den Ohren
dagegen können Sie vergessen. Es gibt keinen Grund, sich deshalb operieren oder
den Ohrknorpel durchstechen zu lassen.`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;